export default "__VITE_ASSET__BkgKre$P__"